/* global jQuery,$,document,window,CartApps,console */
// Retina Images
var isRetina =
  window.devicePixelRatio > 1 ||
  (window.matchMedia &&
    window.matchMedia(
      '(-webkit-min-device-pixel-ratio: 1.5),(-moz-min-device-pixel-ratio: 1.5),(min-device-pixel-ratio: 1.5)'
    ).matches);

/**
 * Search Prompt
 */
$(document).ready(function () {
  $('[type="search"]').on('keypress', function (e) {
    var isEnterKey = e.which == 13;
    if (isEnterKey) {
      e.preventDefault();
      window.location = '/search?q=' + encodeURIComponent(this.value);
    }
  });

  var searchToggleSelector = '.search-toggle-button';
  var searchToggle = $(searchToggleSelector);
  var searchContainerSelector = '.search-prompt-container';
  var searchContainer = $(searchContainerSelector);

  // attach a handler to the `body` element to detect clicks that may be "outside" of the search prompt container.
  $('body').on('click.searchcontainer', function (e) {
    var target = $(e.target);
    var isToggleEvent = target.closest(searchToggleSelector).length > 0;
    var isOutsideEvent = target.closest(searchContainerSelector).length === 0;
    // on any body click:
    // if the search prompt container is visible and the click event occurred outside the search prompt container
    // and the click event did not occur on the search toggle button, then hide the search prompt container.
    if (searchContainer.is(':visible') && isOutsideEvent && !isToggleEvent) {
      searchContainer.hide();
    }
  });

  searchToggle.on('click', function () {
    searchContainer.toggle();
  });

  searchContainer.find('.search-close-btn').on('click', function () {
    searchContainer.hide();
  });

  // When opening overlays such as the cart and mobile nav, the toggle click event does not propagate up.
  // So our `click.searchcontainer` handler in the code above does not fire.
  // Therefore, we subscribe to the custom `showoverlay` event that is triggered when overlays are opened,
  // and close the search container if it is open.
  window.Miadonna.subscribe('showoverlay', function () {
    searchContainer.hide();
  });
});

jQuery(document).ready(function ($) {
  if ($('.hero-slider').length) {
    hero_slider.init();
  }

  if ($('.collection-preview-index').length) {
    collections_slider_init();
    $(window).resize(collections_slider_init);
  }

  if ($('.staff-picks-layout').length) {
    staff_picks_init();
    // $(window).resize(staff_picks_init);
  }

  if ($('.featured-in-logos').length) {
    featured_in_slider();
  }

  // Top Banner slider in product detail page and slider in featured product sections
  setImageDetailsTrigger();

  // 'Wear it with' related product slider in product detail page
  initializeRelatedProductSlider();

  // initializeFeaturesSlider();
});

/* Hero Slider */
var hero_slider = {
  selectors: {
    slider: '.hero-slider',
    content: '._header, ._content',
  },

  elements: {
    $slider: null,
  },

  init: function () {
    this.elements.$slider = $(this.selectors.slider);

    this.elements.$slider
      .on('init', $.proxy(hero_slider.begin, hero_slider))
      .on('afterChange', $.proxy(hero_slider.intro, hero_slider))
      .on('beforeChange', $.proxy(hero_slider.exit, hero_slider))
      .slick({
        arrows: false,
        autoplay: home_hero_slider_options.autoplay,
        autoplaySpeed: home_hero_slider_options.speed,
        dots: home_hero_slider_options.dots,
        fade: home_hero_slider_options.fade,
        speed: 1000,
      });
  },

  begin: function (event, slick) {
    slick.$slides.first().find(this.selectors.content).addClass('fadeInUp');

    if (slick.options.dots) {
      slick.$dots.addClass('animated fadeInUp');

      if (slick.$slides.first().hasClass('content-right')) {
        slick.$dots.addClass('right');
      }
    }
  },

  intro: function (event, slick, currentSlide) {
    slick.$slides.eq(currentSlide).find(this.selectors.content).removeClass('fadeOutUp').addClass('fadeInUp');

    if (slick.options.dots) {
      if (slick.$slides.eq(currentSlide).hasClass('content-right')) {
        slick.$dots.addClass('right');
      } else {
        slick.$dots.removeClass('right');
      }

      slick.$dots.removeClass('fadeOutUp').addClass('fadeInUp');
    }
  },

  exit: function (event, slick, currentSlide, nextSlide) {
    slick.$slides.eq(currentSlide).find(this.selectors.content).removeClass('fadeInUp').addClass('fadeOutUp');

    if (slick.options.dots) {
      slick.$dots.removeClass('fadeInUp').addClass('fadeOutUp');
    }
  },
};

/* Staff Picks Slider */
function staff_picks_init() {
  var wrapper = $('.staff-picks-slider');

  if ($('.staff-picks-slider .slick-initialized').length) {
    wrapper.slick('unslick');
  }

  wrapper.on('init reInit', function (event, slick, currentSlide, nextSlide) {
    var product_info_frame = $(this).parents('.staff-picks-layout').find('.staff-picks-info .inner');
    var current_product_info = $(slick.$slides.get(nextSlide)).find('.info').html();

    product_info_frame.html(current_product_info);
  });

  wrapper.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var product_info_frame = $(this).parents('.staff-picks-layout').find('.staff-picks-info .inner');
    var current_product_info = $(slick.$slides.get(nextSlide)).find('.info').html();

    product_info_frame.html(current_product_info);
  });

  wrapper.slick({
    adaptiveHeight: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    centerPadding: '100px',
    speed: 300,
    infinite: true,
    arrows: true,
    centerMode: true,
    focusOnSelect: true,
    verticalSwiping: false,
    appendArrows: $('.staff-picks-info'),
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
    responsive: [
      {
        breakpoint: 749,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          centerPadding: '200px',
          infinite: true,
        },
      },
      {
        breakpoint: 1023,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          centerPadding: '300px',
          infinite: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          centerMode: true,
          slidesToShow: 5,
          centerPadding: '0',
          infinite: true,
        },
      },
      {
        breakpoint: 2100,
        settings: {
          centerMode: true,
          slidesToShow: 7,
          centerPadding: '0',
          infinite: true,
        },
      },
    ],
  });

  /* Let User navigate slideshow by clicking on slides that aren't active, reenable click functionality when it's active */
  wrapper.find('.slick-slide a').on('click', function (e) {
    if ($(this).parents('.slick-current').length < 1) {
      e.preventDefault();
    }
  });
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function featured_in_slider() {
  var wrapper = $('.featured-in-logos');
  var opts = {
    adaptiveHeight: true,
    slidesToShow: 1,
    mobileFirst: true,
    speed: 300,
    arrows: true,
    verticalSwiping: false,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: 'unslick',
      },
    ],
  };

  if ($('.featured-in-logos.slick-initialized').length) {
    wrapper.slick('unslick');
  }

  var checkReslick = debounce(function () {
    if ($(window).width() <= 768) {
      $('.featured-in-logos:not(.slick-initialized)').slick(opts);
    } else {
      wrapper.slick('unslick');
    }
  }, 250);

  window.addEventListener('resize', checkReslick);

  wrapper.slick(opts);
}

/**
 * Our Story - Wistia Functionality
 */
window._wq = window._wq || [];
_wq.push({
  id: 'r44nua1hjr',
  onReady: function (video) {
    video.bind('play', function () {
      $(video.container).closest('.wistia-video').children('.overlay-container, .play-button').addClass('fade');
      return video.unbind;
    });
    video.bind('end', function () {
      $(video.container).closest('.wistia-video').children('.overlay-container, .play-button').removeClass('fade');
      return video.unbind;
    });
  },
});

/**
 * Collections Filtering
 */
function collections_slider_init() {
  var wrapper = $('.collection-preview-index');

  if ($('.slick-initialized').length) {
    wrapper.slick('unslick');
  }

  wrapper.slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: true,
    arrows: true,
    dots: true,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></button>',
    responsive: [
      // {
      //   breakpoint: 749,
      //   settings: 'unslick'
      // }
      {
        breakpoint: 749,
        settings: 'unslick',
      },
    ],
  });
}

jQuery(document).ready(function ($) {
  'use strict';

  $('#send-hint-form').submit(function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    var $form = $(e.currentTarget);
    var $button = $form.find('button[type="submit"]');
    var buttonText;
    var $alerts;

    if (!$button.prop('disabled')) {
      buttonText = $button.text();
      $button.text('Sending...').prop('disabled', true);
      $alerts = $form.find('footer .email-alert').fadeOut();

      var data = {
        hintToName: $form.find('input[name="hint_to_name"]').val(),
        hintToEmail: $form.find('input[name="hint_to_email"]').val(),
        hintFromName: $form.find('input[name="hint_from_name"]').val(),
        hintFromEmail: $form.find('input[name="hint_from_email"]').val(),
        product: $form.find('input[name="product-title"]').val(),
        productURL: document.URL,
        hintMetalPreference: $form.find('select[name="hint_metal_preference"]').val(),
        hintRingSize: $form.find('select[name="hint_ring_size"]').val(),
        hintCenterStone: $form.find('select[name="hint_center_stone"]').val(),
        hintPersonalNote: $form.find('textarea[name="hint_personal_note"]').val(),
      };

      if (validateEmails([data.hintToEmail, data.hintFromEmail])) {
        $.post({
          url: 'https://miadonna-forms-functions.azurewebsites.net/api/SendAHint',
          data: JSON.stringify(data),
          contentType: 'application/json',
          success: function () {
            $button.text(buttonText).prop('disabled', false);
            $form[0].reset();


          $alerts.filter('.email-alert-success').fadeIn().delay(3000).fadeOut('slow');

          $form.closest('._content .overlay-toggle-button').click();
          },
        }).fail(function () {
          $alerts
            .filter('.email-alert-error')
            .text(
              'There was an error sending your hint. Please give us a call at (503) 336-1581 for assistance or try again later.'
            )
            .fadeIn();

          $button.text(buttonText).prop('disabled', false);
        });
      } else {
        $alerts
          .filter('.email-alert-error')
          .text(
            "The email address you entered doesn't appear to be valid. Please check it and try again, or give us a call at (503) 336-1581 for assistance."
          )
          .fadeIn();

        $button.text(buttonText).prop('disabled', false);
      }
    }
  });

  // Overlay tab toggles
  $('.page-overlay-layout ._content .tabs-toggle .toggle').click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $toggle = $(e.currentTarget);
    var $tabs;

    if (!$toggle.hasClass('active')) {
      $tabs = $toggle.closest('.tabs-toggle').siblings('.tabs');

      $toggle.siblings('.toggle').removeClass('active').end().addClass('active');

      $tabs
        .find('.tab')
        .removeClass('active')
        .filter('.' + $toggle.data('target'))
        .addClass('active')
        .end()
        .end()
        .trigger('mdtabs.change', $toggle.data('target'));
    }
  });

  // Product detail featured accordions
  $('.product-single__detail .featured-group .title').click(function (e) {
    e.preventDefault();

    var $group = $(e.currentTarget).closest('.featured-group');
    var imageUrl = $group.data('image');
    var vimeoId = $group.data('video');

    if (!$group.hasClass('active')) {
      var imageEle = $group.closest('.product-single__container').find('.featured-image');
      var videoEle = $group.closest('.product-single__container').find('.featured-video');
      if (vimeoId) {
        imageEle.addClass('d-none');
        videoEle.removeClass('d-none');
      } else {
        videoEle.addClass('d-none');
        imageEle.removeClass('d-none');
        imageEle.attr('src', imageUrl);
      }

      $group.siblings('.featured-group').removeClass('active').end().addClass('active');
    } else {
      $group.removeClass('active');
    }
  });
  $('.product-single__detail .featured-group:first-of-type .title').trigger('click');

  // Product detail question accordions
  $('.product-single__questions .question .title').click(function (e) {
    e.preventDefault();

    $(e.currentTarget).parent('.question').toggleClass('active');
  });

  // Related products tooltips
  var relatedProductShapeIcons = $('.product-single__related ._shapes .shape-icon');
  if (relatedProductShapeIcons.length) {
    relatedProductShapeIcons.tooltip({
      position: {
        my: 'center bottom-15',
        at: 'center top',
        collision: 'flipfit',
      },
      tooltipClass: 'ui-arrow-bottom-center',
    });
  }
}); //end doc ready

function validateEmails(emails) {
  for (var i = 0; i < emails.length; i++) {
    if (isEmpty(emails[i]) || emails[i].length < 6 || emails[i].indexOf('@') < 1) {
      return false;
    }
  }
  return true;
}

function setCookie(key, value, days) {
  var expires = new Date();
  if (typeof days == 'undefined') days = 356;
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + '; path=/; domain=.' + location.hostname;
}

function getCookie(key) {
  var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
  return keyValue ? keyValue[2] : null;
}

function setImageDetailsTrigger() {
  'use strict';

  var productPhotoSlider = {
    selectors: {
      photo_slider: '.product-single__photo-slider',
      thumbnail_container: '.product-single__thumbnails',
      thumbnail_slider: '.product-single__thumbnail-slider',
      counter: '.slide-counter',
    },

    init: function () {
      if (typeof window.__product_images__ === 'undefined') {
        return;
      }

      var thumbnailSlider = $(this.selectors.thumbnail_slider);
      var photoSlider = $(this.selectors.photo_slider);

      var productImages = window.Miadonna.sortProductImages({ images: __product_images__ });

      thumbnailSlider.find('.thumbnail').remove();
      photoSlider.find('.photo').remove();
      productImages.forEach(function (productImage, index) {
        var thumbSrcOrLazy = index >= 5 ? 'data-lazy' : 'src';
        thumbnailSlider.append(
          '<div class="thumbnail"><img ' +
            thumbSrcOrLazy +
            '="' +
            productImage.thumbUrl +
            '" alt="' +
            productImage.alt +
            '" width="55" height="55" /></div>'
        );

        var imageSrcOrLazy = index > 0 ? 'data-lazy' : 'src';
        photoSlider.append(
          '<div class="photo"><a href="#ImagesAndVideosOverlay" class="overlay-toggle-button" data-image-target="#thumb-' +
            index +
            '"><img ' +
            imageSrcOrLazy +
            '="' +
            productImage.url +
            '" alt="' +
            productImage.alt +
            '" width="648" height="648" /></a>' +
            (productImage.alt.indexOf('Sample Image') !== -1 ? '<span class="sample-text">Sample Image</span>' : '') +
            '</div>'
        );
      });

      photoSlider.each(
        $.proxy(function (index, item) {
          var $photo_slider = $(item);
          var $thumbnail_slider = $photo_slider
            .parent()
            .siblings(this.selectors.thumbnail_container)
            .children(this.selectors.thumbnail_slider);

          // Initialize thumbnail slide if present
          if ($thumbnail_slider.length) {
            $thumbnail_slider.slick({
              arrows: true,
              asNavFor: this.selectors.photo_slider,
              nextArrow:
                '<button type="button" class="slick-next"><i class="fa fa-angle-down" aria-hidden="true"></i></button>',
              prevArrow:
                '<button type="button" class="slick-prev"><i class="fa fa-angle-up" aria-hidden="true"></i></button>',
              dots: false,
              focusOnSelect: true,
              lazyLoad: 'ondemand',
              slidesToShow: 6,
              slidesToScroll: 1,
              vertical: true,
              responsive: [
                {
                  breakpoint: 1400,
                  settings: {
                    slidesToShow: 5,
                  },
                },
                {
                  breakpoint: 1280,
                  settings: {
                    slidesToShow: 4,
                  },
                },
              ],
            });
          }

          $photo_slider
            .on('init', function (event, slick) {
              slick.$slider.next(productPhotoSlider.selectors.counter).find('.total').text(slick.slideCount);
            })
            .on('afterChange', function (event, slick, currentSlide) {
              slick.$slider
                .next(productPhotoSlider.selectors.counter)
                .children('.current')
                .text(currentSlide + 1);
            })
            .slick({
              arrows: true,
              asNavFor: $thumbnail_slider.length ? '.product-single__thumbnail-slider' : null,
              nextArrow:
                '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
              prevArrow:
                '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
              dots: false,
              fade: true,
              lazyLoad: 'ondemand',
              slide: '.photo',
              //      responsive      : [
              //        {
              //          breakpoint  : 1023,
              //          settings    : {
              //            arrows    : false
              //          }
              //        }
              //      ]
            });
        }, this)
      );
    },
  };

  productPhotoSlider.init();
}

function initializeFeaturesSlider() {
  var slickElement = $('._features.page-group');

  if (slickElement.length) {
    slickElement.slick({
      arrows: true,
      dots: true,
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></button>',
    });
  }
}

function initializeRelatedProductSlider() {
  'use strict';

  var $product_slider = $('.related-products__slider');

  if ($product_slider.length) {
    $product_slider.find('.related-product').each(function () {
      var productElem = $(this);
      var productId = productElem.data('productid');
      var imageElem = productElem.find('._image .related-product__image');
      if (Array.isArray(window.__related_product_images__[productId])) {
        var relatedProductImages = window.__related_product_images__[productId];
        var allProductImages = window.Miadonna.sortProductImages({
          images: relatedProductImages,
          includeLegacyImages: true,
        });
        imageElem.attr('alt', allProductImages[0].alt);
        imageElem.attr('data-lazy', allProductImages[0].url);
      }
    });

    $product_slider
      .slick({
        arrows: true,
        dots: false,
        items: '.related-product',
        nextArrow:
          '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
        prevArrow:
          '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
            },
          },
        ],
        lazyLoad: 'ondemand',
      })
      .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $(slick.$slides[currentSlide]).find('.shape-icon').tooltip('close');
      });
  }
}

function conditionallyHideDots(pageGroup) {
  var slick = pageGroup.slick('getSlick');
  if (slick.$slides.length > 10) {
    slick.$dots.hide();
  }
}

// Other Scripts
function MiadonnaApp() {
  // this.init();
}

MiadonnaApp.prototype.init = function init() {
  this.prepareOverlays();
  this.prepareStickyMenus();
  this.slideMenu();

  // Instagram feed
  if (typeof Instafeed != 'undefined') {
    var instafeed = new Instafeed({
      get: 'user',
      limit: 20,
      userId: '1318244623',
      accessToken: '1318244623.1677ed0.2edb28ca592345fca9ef3f83c99b4d4c',
      resolution: 'standard_resolution',
      error: function (error) {
        // console.log('Instafeed error', error);
      },
      template:
        '<div class="insta-image instagram-{{orientation}}"><a href="{{link}}"><img src="{{image}}" /><div class="insta-overlay"><div><i class="fa fa-instagram"></i><div class="shop text-style-chapter-title">SHOP NOW</div></div></div></a></div>',
      after: function () {
        $('#instafeed').slick({
          infinite: true,
          slidesToShow: 5,
          slidesToScroll: 5,
          prevArrow: '<i class="fa fa-chevron-left insta-arrow left-arrow"></i>',
          nextArrow: '<i class="fa fa-chevron-right insta-arrow right-arrow"></i>',
          responsive: [
            {
              breakpoint: 980,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 550,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
      },
    });
    if ($('#instafeed').length) instafeed.run();
  }

  // Press tooltips
  pressFilterButtonQuery = $('.press-filter-menu i');
  if (pressFilterButtonQuery.length) {
    pressFilterButtonQuery.tooltip({
      position: {
        my: 'center bottom-20',
        at: 'center top',
        using: function (position, feedback) {
          $(this).css(position);
          $('<div>').addClass('arrow').addClass(feedback.vertical).addClass(feedback.horizontal).appendTo(this);
        },
      },
    });
  }

  // Back buttons
  $('a[href="#back"]').bind('click', function (e) {
    e.preventDefault();
    window.history.go(-1);
  });
};

MiadonnaApp.prototype.prepareOverlays = function prepareOverlays() {
  var container = $('.page-overlay-layout');
  var activationContext = $('body');
  var activationClassName = 'overlay-is-visible';
  var megaMenuActivationClassName = 'overlay-navigation-is-visible';
  var visibilityClassName = 'visible-state';
  var toggleButtons = '.overlay-toggle-button';
  var megaMenuOverlay = $('#MegaMenuOverlay');
  var megaMenuToggles = $('.mega-menu-toggle');
  var views360Selector = 'a.view-360';
  var isActivated = false;
  var activeOverlayName = '';

  // Set hidden by default
  hideOverlay();

  /**
   * Main Nav Mouse IN
   */
  megaMenuToggles.on('mouseenter', function () {
    var menu_name = $(this).attr('for');
    activationContext.addClass(megaMenuActivationClassName);

    $('.menu-panel').removeClass('active');
    $('.menu-panel[data-menu="' + menu_name + '"]').addClass('active');
  });

  /**
   * Main Nav Mouse OUT
   */
  megaMenuToggles.on('mouseleave', function (e) {
    var nextElement = e.toElement || e.relatedTarget;
    nextElement = $(nextElement);

    if (!nextElement.hasClass('mega-menu') && nextElement.parents('.mega-menu').length < 1) {
      activationContext.removeClass(megaMenuActivationClassName);
    }
  });

  /**
   * Mega Menu Mouse IN
   */
  megaMenuOverlay.on('mouseenter', function () {
    activationContext.addClass(megaMenuActivationClassName);
  });

  /**
   * Mega Menu Mouse OUT
   */
  megaMenuOverlay.on('mouseleave', function (e) {
    var nextElement = e.toElement || e.relatedTarget;
    nextElement = $(nextElement);

    if (!nextElement.hasClass('mega-menu-toggle')) {
      activationContext.removeClass(megaMenuActivationClassName);
    }
  });

  // Toggle visibility for toggle toggleButtons
  $('body').on('click', toggleButtons, function (e, eventData) {
    var isActivated =
      activationContext.hasClass(activationClassName) || activationContext.hasClass(megaMenuActivationClassName);
    var target = $('[for="' + this.hash.replace('#', '') + '"]', container);

    // var resolveTarget = function (toggleButton) {
    //   console.log('toggleButton', toggleButton, toggleButton.context.hash);
    //   // `hash` is the `href` attribute of the clicked element, if said attribute is populated
    //   if (toggleButton.context.hash) {
    //     return $('[for="' + toggleButton.context.hash.replace('#', '') + '"]', container);
    //   } else {
    //     const overlayNameTarget = toggleButton.data('overlay-name-target');
    //     console.log('overlayNameTarget', overlayNameTarget);
    //     return $('[data-overlay-name="' + overlayNameTarget + '"]');
    //   }
    // };

    // var target = resolveTarget($(this));
    // console.log('target', target);

    if ($(this).hasClass('navicon-button')) {
      activationContext.addClass(megaMenuActivationClassName);
    }

    e.preventDefault();
    e.stopPropagation();

    if (isActivated) {
      hideOverlay();
    } else {
      showOverlay(target, e, eventData);
    }
  });

  $('body').on('click', '#purchaseHasPower .wistia-video', function (e) {
    var isActivated =
      activationContext.hasClass(activationClassName) || activationContext.hasClass(megaMenuActivationClassName);
    var target = $('[for="PurchaseHasPowerVideo"]', container);

    if ($(this).hasClass('navicon-button')) {
      activationContext.addClass(megaMenuActivationClassName);
    }

    e.preventDefault();
    e.stopPropagation();

    if (isActivated) {
      target.find('iframe').attr('src', '');
      hideOverlay();
    } else {
      target.find('iframe').attr('src', 'https://player.vimeo.com/video/173554573?autoplay=1');
      showOverlay(target, e);
    }
  });



  // Handle Video buttons
  $('body').on('click', 'a[href*="vimeo"]', function (e) {
    var $link = $(e.currentTarget);

    if ($link[0].pathname !== '/miadonnacompany') {
      e.stopPropagation();
      e.preventDefault();

      $('#VideoOverlay iframe').attr('data-src', 'https://player.vimeo.com/video' + $link[0].pathname);
      showOverlay($('[for="VideoOverlay"]', container));
    }
  });

  //  // Handle 360 views
  $('body').on('click', views360Selector, function (e) {
    e.stopPropagation();
    e.preventDefault();

    var url = $(this).attr('href');
    var vendor = $(this).attr('data-vendor');
    var target = $('[for="ViewOverlay"]', container);

    var viewOverlay = $('#ViewOverlay');
    viewOverlay.find('iframe').attr('data-src', url);
    viewOverlay.find('.view-embed').addClass(vendor);
    showOverlay(target);
  });

  // Handle Blog Filter Buttons
  activationContext.on('click', 'a[href*="BlogFilterOverlay"]', function (e) {
    e.stopPropagation();
    e.preventDefault();
    var param = $(this).attr('data-param');
    var filterBlocks = $('.blog-filter');
    filterBlocks.each(function () {
      $(this).toggle($(this).attr('data-type') == param);
    });
  });

  // Hide with ESC keypress
  activationContext.on('keypress', function (e) {
    var isEscKey = e.which == 27;
    if (isEscKey && isActivated) hideOverlay();
  });

  activationContext.on('click', function (e) {
    if (!isActivated) {
      return;
    }

    var target = $(e.target);
    var overlaySelectors = [
      '#CartOverlay',
      '#NavigationOverlay',
      '#MegaMenuOverlay',
      '#HintOverlay',
      '#ImagesAndVideosOverlay',
      '#VideoOverlay',
      '#BlogFilterOverlay',
      '#CartOverlay',
      '#HomeTryOnOverlay',
      '.overlay-toggle-button',
      '#slide-menus',
      '.fs-detail-container',
    ];

    var eventOccurredOutsideOverlay = overlaySelectors.every(function (selector) {
      var overlayContainer = target.closest(selector);
      return overlayContainer.length == 0;
    });

    if (eventOccurredOutsideOverlay) {
      hideOverlay();
    }
  });

  var _this = this;
  // Show an overlay
  function showOverlay(target, e, eventData) {
    _this.triggerEvent('showoverlay');

    isActivated = true;
    var targetFor = target.first().attr('for');
    activeOverlayName = targetFor;

    if (targetFor === 'MegaMenuOverlay') {
      activationContext.addClass(megaMenuActivationClassName);
    } else {
      activationContext.addClass(activationClassName);
    }

    target.addClass(visibilityClassName);

    if (targetFor != 'HintOverlay' && targetFor != 'CartOverlay') {
      var input = target.find('input');
      if (input) input.focus();
    }

    //ensure that videos set to auto-play don't play unless the video overlay is triggered.
    //otherwise the video may play for any overlay that is triggered.
    if (targetFor == 'VideoOverlay') {
      var videoEmbed = target.find('iframe');
      if (videoEmbed.length) {
        var src = videoEmbed.attr('data-src');
        videoEmbed.attr('src', src);
      }
    }

    // 360 videos
    if (target.attr('for') == 'ViewOverlay') {
      var viewEmbed = target.find('iframe');
      if (viewEmbed.length) {
        var src = viewEmbed.attr('data-src');
        viewEmbed.attr('src', src);
      }
    }

    if (targetFor == 'CartOverlay') {
      raiseEvent(CartApps.CartView.eventNames.cartViewOpened, eventData, document);
      CartApps.CartView.render().catch(function (err) {
        console.error(err);
      });
    }

    // Images and Videos
    if (targetFor == 'ImagesAndVideosOverlay') {
      var thumbnailSlider = target.find('.product-thumbnails');
      var photoContainer = target.find('.photos');

      // if the thumbnails/photos have already been rendered once, don't render again
      if (!photoContainer.hasClass('loaded') && thumbnailSlider.find('.thumbnail').length) {
        var photoSlider = target.find('.product-photo');

        var productImages = window.Miadonna.sortProductImages({
          images: __product_images__,
          includeLegacyImages: true,
        });

        thumbnailSlider.find('.thumbnail').remove();
        photoSlider.find('.photo').remove();

        productImages.forEach(function (productImage, index) {
          var thumbSrcOrLazy = index >= 0 ? 'data-lazy' : 'src';
          thumbnailSlider.append(
            '<div class="thumbnail' +
              (index === 0 ? ' active' : '') +
              '"><img id="thumb-' +
              index +
              '" ' +
              thumbSrcOrLazy +
              '="' +
              productImage.thumbUrl +
              '" alt="' +
              productImage.alt +
              '" width="55" height="55" /></div>'
          );

          var imageSrcOrLazy = index > 0 ? 'data-lazy' : 'src';
          photoSlider.append(
            '<div class="photo"><p class="caption">' +
              productImage.caption +
              '</p><img ' +
              imageSrcOrLazy +
              '="' +
              productImage.url +
              '" alt="' +
              productImage.alt +
              '" width="648" height="648" />' +
              (productImage.alt.indexOf('Sample Image') !== -1 ? '<span class="sample-text">Sample Image</span>' : '') +
              '</div>'
          );
        });

        var thumbnails = thumbnailSlider.find('.thumbnail');

        photoSlider = photoContainer
          .addClass('loaded')
          .find('.product-photo')
          .slick({
            arrows: true,
            nextArrow:
              '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
            prevArrow:
              '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
            dots: false,
            fade: true,
            lazyLoad: 'ondemand',
            slide: '.photo',
          })
          .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            thumbnails.removeClass('active').eq(nextSlide).addClass('active');
          });

        thumbnails
          .each(function (index, item) {
            var $thumbnail = $(item).find('img');

            $thumbnail.attr('src', $thumbnail.data('lazy')).click(function (e) {
              e.stopPropagation();

              var $image = $(e.currentTarget);

              photoSlider.slick('slickGoTo', thumbnails.index($image.parent()));
            });
          })
          .first()
          .find('img')
          .click();
      }

      var $videoContainer = target.find('.videos');
      var $videoThumbnails = target.find('.product-videos a');
      var $video;
      var $tabs;

      if (!$videoContainer.hasClass('loaded') && $videoThumbnails.length) {
        $video = $videoContainer.addClass('loaded').find('.product-video .responsive-video');
        $tabs = target.find('.tabs');

        $videoThumbnails.click(function (e) {
          e.preventDefault();
          e.stopPropagation();

          var $videoThumb = $(e.currentTarget);

          if (!$videoThumb.hasClass('active')) {
            $videoThumb.siblings('a').removeClass('active').end().addClass('active');

            $video.find('iframe').attr('src', $videoThumb.data('iframe-src')).end().show();
          }
        });

        $tabs.on('mdtabs.change', function (e, item) {
          if (!$videoThumbnails.hasClass('active')) {
            $videoThumbnails.first().click();
          }
        });
      }

      function setupInstagramTab() {
        // get the element within the overlay tab that will contain the instagram content
        var instagramTab = target.find('.tab.instagram');
        var instagramTabContent = instagramTab.find('.content');

        // get the instagram container element from the main page, detach its children,
        // and append them to the overlay tab content container.
        $('.product-instagram-container').children().detach().appendTo(instagramTabContent);

        // The foursixty instagram embed code uses a `scroll` event listener
        // to determine if instagram images are in the viewport. We can't
        // scroll when the overlay is open, so need to manually trigger the `scroll` event.
        raiseEvent('scroll');
      }

      setupInstagramTab();

      // Open video tab if video button was clicked
      if ($(e.currentTarget).data('target') === 'video') {
        target.find('.tabs-toggle .toggle[data-target="videos"]').click();
      }

      // Open image tab if image thumbnail was clicked
      if ($(e.currentTarget).data('image-target')) {
        target.find('.tabs-toggle .toggle[data-target="photos"]').click();
        target.find('.product-thumbnails ' + $(e.currentTarget).data('image-target')).click();
      }
    }
  }

  function hideOverlay() {
    isActivated = false;

    // Update className
    activationContext.removeClass(activationClassName).removeClass(megaMenuActivationClassName);
    $('.' + visibilityClassName, activationContext).removeClass(visibilityClassName);

    // Reset videos
    var videoEmbed = $('#VideoOverlay iframe');
    if (videoEmbed.length) {
      var src = videoEmbed.attr('src');
      videoEmbed.attr('data-src', src);
      videoEmbed.attr('src', '');
    }

    // Reset 360 videos
    var viewEmbed = $('#ViewOverlay iframe');
    if (viewEmbed.length) {
      var src = viewEmbed.attr('src');
      viewEmbed.attr('data-src', src);
      viewEmbed.attr('src', '');
    }

    // Reset Wistia video
    var wistiaEmbed = $('#purchaseHasPower .wistia-video');
    if ( wistiaEmbed.length ) {
      var target = $('[for="PurchaseHasPowerVideo"]', container);
      target.find('iframe').attr('src', '');
    }

    if (activeOverlayName == 'ImagesAndVideosOverlay') {
      $('#' + activeOverlayName)
        .find('.tab.instagram .content')
        .children()
        .detach()
        .appendTo($('.product-instagram-container'));
    }

    activeOverlayName = '';
  }

  function raiseEvent(eventName, eventData, domElement) {
    if (eventName) {
      var resolvedDomElement = domElement || window;
      if (typeof window.CustomEvent === 'function') {
        var event = new CustomEvent(eventName, {
          detail: eventData,
        });
        resolvedDomElement.dispatchEvent(event);
      } else {
        var event = window.createEvent('CustomEvent');
        event.initCustomEvent(eventName, true, true, eventData);
        resolvedDomElement.dispatchEvent(event);
      }
    }
  }
};

MiadonnaApp.prototype.prepareStickyMenus = function prepareStickyMenus() {
  // @TODO: This implementation is not fully generalized, but close
  var menus = $('.sticky-menu');
  var menuRects = [];
  var STICKY_CLASS_NAME = 'sticky-state';
  var activationGuide = {
    top: 0,
  };

  // First-run preparation
  prepareAll();

  // Determine activation metrics and size rects to prevent layout jumping
  function prepareAll() {
    var header_buffer = 60;

    menus.each(function (i, el) {
      el = $(el);

      menuRects[i] = el.parents('.sticky-menu-rect').eq(0);
      menuRects[i].height(el.height());

      var offset = 0;

      if (el.data('activationtop')) {
        offset = el.data('activationtop');
      } else {
        offset = menuRects[i].offset().top - activationGuide.top - header_buffer;
      }

      el.data('activationGuide.top', offset);
    });
  }

  // Activate sticky state if element will be scrolled out of view
  function activateIfNecessary() {
    menus.each(function (i, el) {
      el = $(el);

      // Scroll position - Extended Browser Support - document.body.scrollTop is deprecated
      var scrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

      var isActivated = scrollPos > el.data('activationGuide.top');

      if (isActivated) {
        el.addClass(STICKY_CLASS_NAME);
      } else {
        el.removeClass(STICKY_CLASS_NAME);
      }
    });
  }

  $(window)
    // On scroll, activate stickiness if necessary
    .bind('scroll', function (e) {
      activateIfNecessary();
    })
    // On window resize, reprare and recheck for activation
    .bind('resize', function (e) {
      prepareAll();
      activateIfNecessary();
    });
};

MiadonnaApp.prototype.slideMenu = function slideMenu() {
  var slideMenus = $('#slide-menus');
  var slidesWrapper = slideMenus.find('.nav-wrap');
  var parentMenu = '';

  function removeLevels() {
    slidesWrapper.removeClass('slide-2x').removeClass('slide-3x');
  }

  function filterItems(filter) {
    if (filter) {
      $('[data-group]').addClass('hide');
      $('[data-group="' + filter + '"]').removeClass('hide');
    } else {
      $('[data-group]').removeClass('hide');
    }
  }

  function setParent(parent) {
    parentMenu = parent;
  }

  slideMenus.find('a[data-submenu]').on('click', function () {
    var level = $(this).parents('.slide-menu').data('level');
    var group = $(this).parents('.has-submenu').data('group');

    setParent($(this).data('parent'));
    filterItems($(this).data('submenu'));
    removeLevels();

    slidesWrapper.addClass('slide-' + (level + 1) + 'x');

    return false;
  });

  slideMenus.find('a.menu-breadcrumb.back').on('click', function () {
    var level = $(this).parents('.slide-menu').data('level');

    filterItems(parentMenu);
    removeLevels();

    parentMenu = '';

    slidesWrapper.addClass('slide-' + (level - 1) + 'x');

    return false;
  });

  slideMenus.find('.menu-close').on('click', function () {
    $('body').removeClass('overlay-is-visible overlay-navigation-is-visible');

    removeLevels();
    setParent('');
    filterItems('');

    return false;
  });
};

MiadonnaApp.prototype.triggerEvent = function (eventName, eventData) {
  if (Array.isArray(this.subscriptions[eventName])) {
    this.subscriptions[eventName].forEach(function (subscriber) {
      subscriber(eventData);
    });
  }
};

MiadonnaApp.prototype.subscribe = function (eventName, subscriber) {
  if (!this.subscriptions) {
    this.subscriptions = {};
  }
  Array.isArray(this.subscriptions[eventName])
    ? this.subscriptions[eventName].push(subscriber)
    : (this.subscriptions[eventName] = [subscriber]);
};

MiadonnaApp.prototype.sortProductImages = function (options) {
  var images = options.images;
  var includeLegacyImages = options.includeLegacyImages;
  var fallbackToLegacyImages = options.fallbackToLegacyImages;

  if (typeof includeLegacyImages === 'undefined') {
    includeLegacyImages = false;
  }

  if (typeof fallbackToLegacyImages === 'undefined') {
    fallbackToLegacyImages = true;
  }

  /*
  desired image order is:
  Webwhite-001 through Webwhite-004
  Lifestyle-001 through Lifestyle-003
  Webwhite-005 and higher
  Lifestyle-004 and higher
  Legacy images
  */

  var productImages = AppUtils.getCategorizedSortedProductImages(images);

  var webwhiteImages1 = [];
  var webwhiteImages2 = [];
  productImages.webwhite.forEach(function (image) {
    if (image.number <= 4) {
      webwhiteImages1.push(image);
    } else {
      webwhiteImages2.push(image);
    }
  });

  var lifestyleImages1 = [];
  var lifestyleImages2 = [];
  productImages.lifestyle.forEach(function (image) {
    if (image.number <= 3) {
      lifestyleImages1.push(image);
    } else {
      lifestyleImages2.push(image);
    }
  });

  var allProductImages = webwhiteImages1.concat(lifestyleImages1).concat(webwhiteImages2).concat(lifestyleImages2);

  if (includeLegacyImages || (allProductImages.length === 0 && fallbackToLegacyImages)) {
    allProductImages = allProductImages.concat(productImages.legacy);
  }

  return allProductImages;
};

window.Miadonna = new MiadonnaApp();

$(function () {
  window.Miadonna.init();
});

// http://stackoverflow.com/a/12837315
function toInt(flt) {
  return flt | 0;
}

// http://stackoverflow.com/a/1144788
function escapeRegExp(str) {
  return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
}
function replaceAll(str, find, replace) {
  return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}

// http://stackoverflow.com/a/4994244
var hasOwnProperty = Object.prototype.hasOwnProperty;
function isEmpty(obj) {
  // double equals is correct here.
  if (obj == null) return true;
  if (obj.length > 0) return false;
  if (obj.length === 0) return true;
  for (var key in obj) {
    if (hasOwnProperty.call(obj, key)) return false;
  }
  var validTypeofs = ['number', 'string', 'symbol'];
  var type = typeof obj;
  if (validTypeofs.indexOf(type) >= 0) return false;
  return true;
}

// http://stackoverflow.com/a/17936490
function sleepFor(sleepDuration) {
  var now = new Date().getTime();
  while (new Date().getTime() < now + sleepDuration) {}
}

function arrayToObject(array) {
  var obj = {};
  array.forEach(function (val, index) {
    if (index % 2 === 0) {
      obj[val] = array[index + 1];
    }
  });
  return obj;
}

Array.prototype.remove = function (elementToRemove) {
  var newArray = [];
  for (var i = 0; i < this.length; i++) {
    if (this[i] != elementToRemove) {
      newArray.push(this[i]);
    }
  }
  return newArray;
};

// http://stackoverflow.com/a/3291856
String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

// https://codepad.co/snippet/zRykJud8
String.prototype.titleize = function () {
  var string_array = this.split(' ');
  string_array = string_array.map(function (str) {
    return str.capitalize();
  });

  return string_array.join(' ');
};

// http://stackoverflow.com/a/21963136
var lut = [];
for (var i = 0; i < 256; i++) {
  lut[i] = (i < 16 ? '0' : '') + i.toString(16);
}
function generateGUID() {
  var d0 = (Math.random() * 0x100000000) >>> 0;
  var d1 = (Math.random() * 0x100000000) >>> 0;
  var d2 = (Math.random() * 0x100000000) >>> 0;
  var d3 = (Math.random() * 0x100000000) >>> 0;
  return (
    lut[d0 & 0xff] +
    lut[(d0 >> 8) & 0xff] +
    lut[(d0 >> 16) & 0xff] +
    lut[(d0 >> 24) & 0xff] +
    '-' +
    lut[d1 & 0xff] +
    lut[(d1 >> 8) & 0xff] +
    '-' +
    lut[((d1 >> 16) & 0x0f) | 0x40] +
    lut[(d1 >> 24) & 0xff] +
    '-' +
    lut[(d2 & 0x3f) | 0x80] +
    lut[(d2 >> 8) & 0xff] +
    '-' +
    lut[(d2 >> 16) & 0xff] +
    lut[(d2 >> 24) & 0xff] +
    lut[d3 & 0xff] +
    lut[(d3 >> 8) & 0xff] +
    lut[(d3 >> 16) & 0xff] +
    lut[(d3 >> 24) & 0xff]
  );
}

// http://stackoverflow.com/a/15806501
Array.prototype.unique = function () {
  var unique = [];
  for (var i = 0; i < this.length; i++) {
    if (unique.indexOf(this[i]) == -1) {
      unique.push(this[i]);
    }
  }
  return unique;
};

// Closable Divs
$(function () {
  var closableDivs = $('[data-closable]');
  if (closableDivs.length) {
    closableDivs.each(function () {
      var closeButton = $(this).find('[data-close]');
      closeButton.click(function () {
        $(this).parent().remove();
      });
    });
  }
});

// Pinterest
$(function () {
  var pinOneButton = $('.pinterest');
  if (pinOneButton.length) {
    pinOneButton.click(function (e) {
      PinUtils.pinOne({
        media: e.target.getAttribute('data-media'),
        description: e.target.getAttribute('data-description'),
        url: e.target.getAttribute('data-url'),
      });
    });
  }
});

// Home Page Featured Products
$(function () {
  var featuredProductMenu = $('nav.featured-products-home');
  if (featuredProductMenu.length) {
    featuredProductMenu.children().click(function (e) {
      assignActiveFeaturedProducts(e, featuredProductMenu);
    });
  }
});

function assignActiveFeaturedProducts(e, featuredProductMenu) {
  var featuredProductsWrap = $('.featured-products');
  var activeLink = $(e.target);
  var activeSectionId = activeLink.data('featured');
  var featuredProduct = featuredProductsWrap.find('#' + activeSectionId);
  featuredProductMenu.children().removeClass('active');
  featuredProductsWrap.children().removeClass('active');
  activeLink.addClass('active');
  featuredProduct.addClass('active');
}

// Match Heights
$(function () {
  if (typeof $.fn.matchHeight == 'undefined') return;

  $('.sustainable-practices').matchHeight();
  $('.the-result .result-block h2').matchHeight();
  $('.card-layout > section').matchHeight();
  $('.masonry-grid img').matchHeight();
  $('.blog-article header h2').matchHeight();
  $('.blog-article > h3').matchHeight();
  $('.blog-article > blockquote').matchHeight();
});

// Blog Filter
$(function () {
  if (document.URL.indexOf('&type=article&filter=') != -1) {
    var url = parseURL(document.URL);
    var search = url.search.split('&filter=');
    var type = search[search.length - 1];
    $('a[href*="BlogFilterOverlay"]').each(function () {
      if ($(this).attr('data-param') == type) $(this).addClass('active-state');
    });
  }
});

// Parse URL Helper
function parseURL(url) {
  var parser = document.createElement('a'),
    searchObject = {},
    queries,
    split,
    i;
  // Let the browser do the work
  parser.href = url;
  // Convert query string to object
  queries = parser.search.replace(/^\?/, '').split('&');
  for (i = 0; i < queries.length; i++) {
    split = queries[i].split('=');
    searchObject[split[0]] = split[1];
  }
  return {
    protocol: parser.protocol,
    host: parser.host,
    hostname: parser.hostname,
    port: parser.port,
    pathname: parser.pathname,
    search: parser.search,
    searchObject: searchObject,
    hash: parser.hash,
  };
}

$(document).ready(function () {
  $('#clear-bag').click(function (e) {
    e.preventDefault();

    CartApps.CartManager.clear()
      .then(function () {
        location.reload();
      })
      .catch(function (err) {
        console.error(err);
      });
  });
});

// http://stackoverflow.com/a/9192949
function expon(val, minVal, maxVal) {
  var minv = Math.log(minVal);
  var maxv = Math.log(maxVal);
  var scale = (maxv - minv) / (maxVal - minVal);
  expVal = Math.exp(minv + scale * (val - minVal));
  return expVal;
}

function logposition(val, minVal, maxVal) {
  var minv = Math.log(minVal);
  var maxv = Math.log(maxVal);
  var scale = (maxv - minv) / (maxVal - minVal);
  var logposVal = (Math.log(val) - minv) / scale + minVal;
  return logposVal;
}

function hashString(val) {
  var hash = 0;
  if (val.length === 0) {
    return hash;
  }
  var i, chr;
  for (i = 0; i < val.length; i++) {
    chr = val.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

// promo banner
// when banner is closed by the clicking the close button, set a cookie so that it won't be display on page refresh or subsequent visits
// banner is hidden by default to prevent flicker on page load
$(document).ready(function () {
  var promoBanner = $('.promo-banner,.promo-banner-link');
  if (!promoBanner.length) {
    return;
  }

  var msg = promoBanner.find('.promo-banner-message').text();
  var hash = hashString(msg).toString();
  var page = window.location.pathname;
  var cookieVal = getCookie('promo-banner-closed-' + page);
  if (!cookieVal || cookieVal !== hash) {
    promoBanner.removeClass('hidden');
  }

  promoBanner.find('.close-button').on('click', function () {
    setCookie('promo-banner-closed-' + page, hash, 365);
  });
});

// Counter
$(document).ready(function () {
  $('.count').each(function () {
    $(this)
      .prop('Counter', 0)
      .animate(
        {
          Counter: $(this).text(),
        },
        {
          duration: 12000,
          easing: 'swing',
          step: function (now) {
            $(this).text(Math.ceil(now));
          },
        }
      );
  });
});

$(document).ready(function () {
  $('.subnav-trigger').click(function (e) {
    e.preventDefault();

    var target = $(e.target);
    var parent = target.parents('.expander');

    parent.hasClass('active') ? parent.removeClass('active') : parent.addClass('active');
  });
});

$(function () {
  if ($('.video-embed-wrapper').length) {
    resizeAllVideos();
    window.addEventListener('resize', resizeAllVideos, false);
  }
  if ($('#the-journal-blog').length || $('body.search').length) {
    getArchives(window.location.protocol + '//' + window.location.host + '/pages/archive-filter-json');
  }
});

function getArchives(url) {
  $.ajax({
    url: url,
    success: function (data) {
      var start = data.indexOf('<!-- begin JSON -->');
      var end = data.indexOf('<!-- end JSON -->');
      if (start > 0 && end > 0) data = data.slice(start + '<!-- begin JSON -->'.length, end);

      var formattedData = data.replace(/<.+>.+?<\/.+>/g, '');
      var json = JSON.parse(formattedData);
      var months = [];
      var newArticles = [];
      json.articles.forEach(function (article, i) {
        var dateParts = article.date.split(' ')[0].split('-');
        var year = parseInt(dateParts[0]);
        var month = parseInt(dateParts[1] - 1); // months are 0-based in javascript Date object
        var day = parseInt(dateParts[2]);
        var objDate = new Date(year, month, day),
          locale = 'en-us';
        month = objDate.toLocaleString(locale, { month: 'long' });
        year = objDate.getFullYear();
        var dateString = month + ' ' + year;
        var articleObj = {
          title: article.title,
          url: article.url,
          date: dateString,
        };
        newArticles.push(articleObj);
        if (months.indexOf(dateString) == -1) months.push(dateString);
      });
      var newMonths = months.map(function (month) {
        return { month: month, articles: [] };
      });
      for (var i = 0; i < newArticles.length; i++) {
        for (var j = 0; j < newMonths.length; j++) {
          if (newArticles[i].date == newMonths[j].month) newMonths[j].articles.push(newArticles[i]);
        }
      }
      var html = '';
      newMonths.forEach(function (month) {
        html += '<h4 class="text-style-subtitle text-effect-white">' + month.month + '</h4>';
        month.articles.forEach(function (article) {
          html += '<div><a href="' + article.url + '" style="font-size:0.9em">' + article.title + '</a></div>';
        });
      });
      $('.archive-months').html(html);
    },
    error: function (e) {
      // console.log('error: ', e);
    },
  });
}

function resizeAllVideos() {
  var containers = $('.video-embed-wrapper');
  var video = document.getElementById('video');
  containers.each(function () {
    var video = $(this).find('iframe');
    resizeVid(this, video);
  });
}

function resizeVid(container, video) {
  var ratio = 9 / 16;
  var width = parseInt(window.getComputedStyle(container).width);
  var height = width * ratio;
  video.css({ width: width + 'px', height: height + 'px' });
}

$(function () {
  var bannerProductInfo = $('#banner-product-info');
  if (bannerProductInfo.length) {
    var trigger = bannerProductInfo.find('._trigger');
    var content = bannerProductInfo.find('._content');
    trigger.click(function (e) {
      if (!trigger.hasClass('active')) {
        trigger.text('-');
        trigger.addClass('active');
        content.fadeIn();
      } else {
        trigger.text('+');
        trigger.removeClass('active');
        content.fadeOut();
      }
    });
  }
});

$(function () {
  var imageCaptionTrigger = $('.image-caption-trigger');
  imageCaptionTrigger.on('click', function (e) {
    $('.product-preview-layout .slick-active').find('.image-caption-wrapper').toggleClass('active');
    imageCaptionTrigger.toggleClass('active');
  });
});

// set the height of the features carousel text to match the height of the hero image
$(function () {
  var $track = $('._features.page-group');
  var inspector = $('._inspector');
  $track.on('setPosition', function () {
    inspector.find('figure').css('height', $track.height());
  });
});

$(function () {
  var closeButton = $('.close-button');
  closeButton.on('click', function (e) {
    e.preventDefault();
    $(this).parent().hide();
  });
});
jQuery(document).ready(function ($) {
  $('footer .site-footer-layout ._menu header').click(function () {
    var $item = $(this).closest('section');

    $item.siblings('section').removeClass('open').end().addClass('open');
  });

  if ($('.capsule-collection-content .image-product-info .trigger').length) {
    $('.capsule-collection-content .image-product-info .trigger').click(function (e) {
      var trigger = $(e.currentTarget);
      var content = trigger.closest('.image-product-info').find('.pop-content');

      if (trigger.hasClass('active')) {
        trigger.removeClass('active').closest('.image-product-info').find('.pop-content').fadeOut();
      } else {
        trigger.addClass('active').closest('.image-product-info').find('.pop-content').fadeIn();
      }
    });
  }
});
